class VelaquinDelivery extends HTMLElement {
  connectedCallback() {
    document.addEventListener('variant:update', this.onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:update', this.onVariantUpdate);
  }

  onVariantUpdate = (event) => {
    const data = event.detail?.data;
    if (String(data?.productId) !== this.dataset.productId) return;
    const section = this.closest('.shopify-section');
    if (section && !section.contains(event.target)) return;
    const updated = data.html?.querySelector(
      'velaquin-delivery[data-product-id="' + this.dataset.productId + '"]'
    );
    if (updated) {
      this.replaceChildren(...Array.from(updated.childNodes, (node) => node.cloneNode(true)));
    }
  };
}

if (!customElements.get('velaquin-delivery')) {
  customElements.define('velaquin-delivery', VelaquinDelivery);
}
